import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from 'reactstrap';

import { PathsLayouts } from '../../../../config/routes';
import { TranslationsKeys } from '../../../../locales/translations';

export function CreateButton() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_STUDY_PLANS,
  );
  const history = useHistory();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleCreateCourse = () => {
    history.push(`${PathsLayouts.continuousEducation}/study-plans/course`);
  };

  const handleCreateProgram = () => {
    history.push(
      `${PathsLayouts.continuousEducation}/study-plans/program-course`,
    );
  };

  return (
    <Row className="mt-3">
      <Col xs={12} md={6} lg={3} className="offset-md-6 offset-lg-9">
        <Dropdown
          isOpen={dropdownOpen}
          toggle={toggle}
          style={{ width: '100%' }}
        >
          <DropdownToggle
            style={{ width: '100%' }}
            className="g-button text-uppercase"
            color="primary"
            size="md"
            caret
          >
            <span>{t('common.actions.new')}</span>
          </DropdownToggle>
          <DropdownMenu style={{ minWidth: '100%' }}>
            <DropdownItem onClick={handleCreateCourse}>
              {t('createOptions.course')}
            </DropdownItem>
            <DropdownItem onClick={handleCreateProgram}>
              {t('createOptions.program')}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
    </Row>
  );
}
